/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { useDemoRequestQuery, useRegisterMutation } from '../../store/auth/authApi';
import PasswordInput from '../../shared/input/passwordInput';
import Button from '../../shared/button';
import Input from '../../shared/input';
import Error from '../../shared/error';


const AiRegister = () => {
    const { search } = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(search);
    const [register] = useRegisterMutation();
    const { data: demoRequest } = useDemoRequestQuery(queryParams?.get('request') || '')
    const [email, setEmail] = useState<string | null>(null);
    const [companyName, setCompanyName] = useState<string | null>(null);
    // const [address, setAddress] = useState<string | null>(null);
    const [username, setUsername] = useState<string>();
    const [password, setPassword] = useState<string>();
    const [repeatPassword, setRepeatPassword] = useState<string>();
    const [fullName, setFullName] = useState<string>();
    const [submitError, setSubmitError] = useState<string>();

    const onGettingRequestData = () => {
        if (demoRequest) {
            if (demoRequest?.email) {
                setEmail(demoRequest?.email)
            }
            if (demoRequest?.companyName) {
                setCompanyName(demoRequest?.companyName)
            }
            // if (demoRequest?.address) {
            //     setAddress('')
            // }
            if (demoRequest?.name) {
                setFullName(demoRequest?.name)
            }

            setSubmitError(undefined)
        } else {
            setSubmitError('We cant find your invitation')
        }
    }

    useEffect(() => {
        if (demoRequest) {
            onGettingRequestData()
        }
    }, [demoRequest])

    const onChangeInputs = (value: any, type?: string) => {
        if (type) {
            switch (type) {
                case 'username':
                    setUsername(value)
                    break;
                // case 'address':
                //     setAddress(value)
                //     break;
                case 'password':
                    setPassword(value)
                    break;
                case 'repeatPassword':
                    setRepeatPassword(value)
                    break;
                case 'companyName':
                    setCompanyName(value)
                    break;
                case 'fullName':
                    setFullName(value)
                    break;
            }
        }
    }

    const onRegisterUser = async () => {
        if (!queryParams?.get('request')) return;
        const isEmpty = (v?: string | null) => !v || v.trim() === '';
        const trim = (v?: string | null) => (v ?? '').trim();

        const _companyName = trim(companyName);
        // const _address = trim(address);
        const _username = trim(username);
        const _password = trim(password);
        const _repeat = trim(repeatPassword);
        const _fullName = trim(fullName);

        const missing: string[] = [];
        if (isEmpty(_fullName)) missing.push('Full name');
        if (isEmpty(_companyName)) missing.push('Company name');
        if (isEmpty(_username)) missing.push('Username');
        // if (isEmpty(_address)) missing.push('Address');
        if (isEmpty(_password)) missing.push('Password');
        if (isEmpty(_repeat)) missing.push('Repeat password');

        if (missing.length) {
            setSubmitError(`Please fill in: ${missing.join(', ')}.`);
            return;
        }

        const passRe = /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{6,}$/;
        if (!passRe.test(_password)) {
            setSubmitError(
                'Password must include 6+ characters and at least 1 uppercase letter, 1 number, and 1 symbol.'
            );
            return;
        }
        if (_password !== _repeat) {
            setSubmitError('Passwords must match.');
            return;
        }
        if (_username.length < 3) {
            setSubmitError('Username must be at least 3 characters.');
            return;
        }

        try {
            setSubmitError(undefined);
            const data = {
                email: email,
                companyName: _companyName,
                // address: _address,
                password: _password,
                username: _username,
                name: _fullName,
            };
            await register(data).unwrap();
            navigate('/auth')
        } catch (err) {
            setSubmitError(`${err}`);
        }
    };


    const passwordsMatch =
        (repeatPassword?.length ?? 0) > 0 && repeatPassword === password;

    const repeatHelperText =
        !repeatPassword
            ? 'Password must match'
            : passwordsMatch
                ? 'Passwords match'
                : 'Passwords do not match';
    const allFilled =
        email &&
        companyName &&
        // address &&
        username &&
        password &&
        repeatPassword &&
        fullName;

    const canSubmit = Boolean(allFilled && passwordsMatch && queryParams?.get('request'));
    return (
        <div className='flex flex-wrap min-h-screen'>
            <div className='w-full md:w-6/12 flex flex-col md:px-5 md:py-10 z-10'>
                <div className='flex flex-wrap px-4 md:px-0'>
                    <img src={'/assets/insights/hotelworld-green.svg'} className='object-contain h-[25px] mb-7 ml-5' />
                </div>
                <div className='w-[100%] m-auto'>
                    <div className='sm:max-w-[95%] md:max-w-[90%] lg:max-w-[75%] m-auto'>
                        <p className='text-center text-3xl text-[#101010] font-bold'>Sign up</p>
                        <p className='mt-2 mb-4 text-center text-[#101010]'>Into your hotel dashboard</p>
                        <div className='flex items-center justify-center my-8'>
                            <div className='flex-grow h-px bg-gray-200'></div>
                            <span className='mx-4 text-gray-400 text-sm'>You have been invited</span>
                            <div className='flex-grow h-px bg-gray-200'></div>
                        </div>
                        {submitError && <Error text={submitError} />}
                        <Input
                            label='Full Name'
                            placeholder=''
                            showValue={true}
                            disabled={!!demoRequest?.name}
                            inputValue={fullName}
                            inputUniqueName='fullName'
                            labelStyle='!text-black !text-sm'
                            inputStyle='!rounded-xl'
                            containerStyle='!mb-0'
                            onChangeInput={onChangeInputs}
                        />
                        <Input
                            label='Work email'
                            placeholder=''
                            disabled={true}
                            showValue={true}
                            inputStyle='!rounded-xl'
                            labelStyle='!text-black !text-sm'
                            containerStyle='!mb-0'
                            inputValue={email || undefined}
                        />
                        <Input
                            label='Company Name'
                            placeholder=''
                            disabled={!!demoRequest?.companyName}
                            showValue={true}
                            inputValue={companyName || undefined}
                            inputUniqueName='companyName'
                            labelStyle='!text-black !text-sm'
                            inputStyle='!rounded-xl'
                            containerStyle='!mb-0'
                            onChangeInput={onChangeInputs}
                        />
                        <Input
                            label='Username'
                            placeholder=''
                            showValue={true}
                            inputValue={username}
                            inputStyle='!rounded-xl'
                            labelStyle='!text-black !text-sm'
                            inputUniqueName='username'
                            containerStyle='!mb-0'
                            onChangeInput={onChangeInputs}
                        />

                        {/* <Input
                            label='Address'
                            placeholder=''
                            disabled={!!demoRequest?.address}
                            showValue={true}
                            inputStyle='!rounded-xl'
                            inputValue={address || undefined}
                            inputUniqueName='address'
                            containerStyle='!mb-0'
                            labelStyle='!text-black !text-sm'
                            onChangeInput={onChangeInputs}
                        /> */}
                        <PasswordInput
                            label='Password'
                            placeholder=''
                            showValue={true}
                            inputValue={password}
                            inputStyle='!rounded-xl'
                            labelStyle='!text-black !text-sm'
                            inputUniqueName='password'
                            containerStyle='!mb-2'
                            onChangeInput={onChangeInputs}
                            helperText='Password must include 6 characters or more and at least 1 uppercase letter, 1 number and 1 symbol'

                        />
                        <PasswordInput
                            label='Repeat Password'
                            placeholder=''
                            showValue={true}
                            inputValue={repeatPassword}
                            inputStyle='!rounded-xl'
                            labelStyle='!text-black !text-sm'
                            inputUniqueName='repeatPassword'
                            containerStyle='!mb-0'
                            onChangeInput={onChangeInputs}
                            helperText={repeatHelperText}
                            error={!passwordsMatch && !!repeatPassword ? 'Passwords do not match' : ''}
                        />
                        <div className='my-4 flex flex-row justify-center'>
                            <Button
                                label='Sign up'
                                className={`btn-primary-rounded-less ${canSubmit ? '' : '!bg-[#819989]'} !rounded-full w-full !py-2`}
                                onClickButton={() => canSubmit && onRegisterUser()}
                            />
                        </div>
                    </div>
                </div>
                <ul className='flex flex-wrap ml-5 text-sm mt-5 mb-3'>
                    <li>Terms</li>
                    <li className='ml-7  list-disc'>Privacy Policy</li>
                </ul>
            </div>
            <div className='hidden md:block md:w-6/12 md:sticky md:top-0 md:h-screen relative'>
                <img
                    alt='Login'
                    className='w-full h-full object-cover'
                    src='/images/register.png'
                />

                <div className='absolute inset-0 flex items-center justify-center'>
                    <div className='bg-white/20 backdrop-blur-xl rounded-xl p-8 max-w-sm text-center text-white flex flex-col items-center'>
                        <img src={'/assets/insights/hotelworld-white.svg'} className='object-contain w-[70%] mb-6' />
                        <p className='text-3xl font-semibold mb-3'>
                            “We believe that people are at the heart of the hotel experience.”
                        </p>
                        <p className='text-xl'>
                            Our goal is to free them from mundane administrative tasks, allowing them to focus on what truly matters.
                        </p>
                    </div>
                </div>

                <div className='absolute bottom-4 right-6 text-xs text-white/90'>
                    © All rights reserved.
                </div>
            </div>
        </div>
    );
};

export default AiRegister;
